
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { DocumentosProvider } from "../../providers/documentos/documentos";
import { Estudo, EstudoCientificoModel } from "./estudos-cientificos.modelview";
import { ListasProvider } from "../../providers/listas/listas";
import { UserProvider } from "../../providers/user/user";
import { environment } from "../../environments/environment.dev";
import { Filter } from "../../providers/http-interceptor/http-interceptor";

@Injectable()
export class EstudosCientificosProvider {

    constructor(
        public documentosProvider: DocumentosProvider,
        public listasProvider: ListasProvider,
        public userProvider: UserProvider) {

    }

    getEstudosCientificos(especialitie?: string): Observable<EstudoCientificoModel> {
        return Observable.create(subscriber => {

            var estudoCientificoModel: EstudoCientificoModel = new EstudoCientificoModel()
            estudoCientificoModel.estudos = []

            this.listasProvider.requestAllLists().subscribe(data => {
                estudoCientificoModel.especialidades = []
                estudoCientificoModel.especialidades.push("Selecione")
                data.especialidades_medico.map(element => {
                    estudoCientificoModel.especialidades.push(element)

                });

                estudoCientificoModel.especialidade = this.userProvider.getUserStoraged().acf.especialidades_medico

                if(especialitie == "Selecione"){
                    estudoCientificoModel.especialidade = undefined
                }

                var filters: Array<Filter>
                
                if (especialitie != undefined && especialitie != "Selecione") {
                    estudoCientificoModel.especialidade = especialitie
                    filters = []

                    var filter: Filter = new Filter()

                    filter.comparation = "LIKE"
                    filter.field = "especialidades_medico"
                    filter.value = estudoCientificoModel.especialidade

                    filters.push(filter)

                } else if (estudoCientificoModel.especialidade != undefined) {
                    filters = []

                    var filter: Filter = new Filter()

                    filter.comparation = "LIKE"
                    filter.field = "especialidades_medico"
                    filter.value = estudoCientificoModel.especialidade

                    filters.push(filter)
                }

                this.documentosProvider.solicitarDocumentos(filters).subscribe(data => {
                    console.log("documentos", data)

                    if (data != undefined) {
                        data.forEach(element => {
                            estudoCientificoModel.estudos.push(this.mapearEstudo(element))
                        });
                    }
                    subscriber.next(estudoCientificoModel)
                }, err => {

                })

            })

        })
    }

    private mapearEstudo(element): Estudo {
        var estudo: Estudo = new Estudo()

        estudo.id = element.id
        estudo.titulo = element.title.rendered
        estudo.descricao = element.content.rendered
        estudo.eNovo = true
        estudo.tipo = element.acf.tipo_documento
        estudo.tags = element.acf.especialidades_medico

        if (element.acf != undefined) {
            estudo.url_documento = (element.acf.url_documento != undefined) ? element.acf.url_documento : environment.principal_link + element.acf.upload_documento
            estudo.upload_documento = (element.acf.upload_documento != undefined) ? element.acf.upload_documento : environment.principal_link + element.acf.upload_documento
            estudo.tipo_documento = element.acf.tipo_documento


            let usuarios_visualizados = element.acf.usuarios_visualizados
            let currentUserId = this.userProvider.getUserStoraged().general.data.ID

            if (usuarios_visualizados != undefined && usuarios_visualizados.indexOf(currentUserId) > -1) {

                estudo.ja_visualizou = true
            } else {
                estudo.ja_visualizou = false
            }
        }
        return estudo
    }

    requestLists(): Observable<any> {
        return this.listasProvider.requestAllLists()
    }

    informVizualization(documentId): Observable<Estudo> {
        return Observable.create(observer => {
            this.documentosProvider.informDocumentVisualization(documentId).subscribe(element => {
                observer.next(this.mapearEstudo(element))
            }, error => {
                observer.error(error)
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/estudos-cientificos/estudos-cientificos.provider.ts